import { render, staticRenderFns } from "./ClosedCampaigns.vue?vue&type=template&id=9ba73fbe&scoped=true"
import script from "./ClosedCampaigns.vue?vue&type=script&lang=ts"
export * from "./ClosedCampaigns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba73fbe",
  null
  
)

export default component.exports